import { FC, PropsWithChildren, ReactNode } from 'react';

import { CardBorderRadius, CardPadding } from '@hh.ru/magritte-ui-card/types';

import styles from './styles.less';

interface BlurryCardContentProps {
    blurred: boolean;
    aboveContent: ReactNode;
    /** скругления заблюренной области. Необходимо `продублировать` этот проп из карточки */
    borderRadius: CardBorderRadius;
    /** внутренние отступы заблюренной области. Необходимо `перенести` этот проп из карточки */
    padding: CardPadding;
}

/**
 * Компонент для блюра содержимого карточки
 */
const BlurryCardContent: FC<PropsWithChildren<BlurryCardContentProps>> = ({
    aboveContent,
    blurred,
    borderRadius,
    children,
    padding,
}) => {
    if (!blurred) {
        return (
            <div className={styles.content} style={{ padding }}>
                {children}
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.content} style={{ padding }}>
                {children}
            </div>
            <div className={styles.aboveContent} style={{ borderRadius }}>
                {aboveContent}
            </div>
        </div>
    );
};

export default BlurryCardContent;
